import { render } from "./DocumentBrowserSidebar.vue?vue&type=template&id=cf05fc3a&scoped=true&ts=true"
import script from "./DocumentBrowserSidebar.vue?vue&type=script&lang=ts"
export * from "./DocumentBrowserSidebar.vue?vue&type=script&lang=ts"

import "./DocumentBrowserSidebar.vue?vue&type=style&index=0&id=cf05fc3a&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf05fc3a"]])

export default __exports__